import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/image/image.png'


const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "home-item" }
const _hoisted_3 = { class: "login-form-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserOutlined = _resolveComponent("UserOutlined")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_UnlockOutlined = _resolveComponent("UnlockOutlined")!
  const _component_LockOutlined = _resolveComponent("LockOutlined")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[4] || (_cache[4] = _createStaticVNode("<div class=\"home-item login-left\" data-v-7725ad76><img class=\"logo\" src=\"" + _imports_0 + "\" data-v-7725ad76><div class=\"logo-text\" data-v-7725ad76><div class=\"logo-text-top\" data-v-7725ad76>Welcome back!</div><div class=\"logo-text-bottom\" data-v-7725ad76>Seamlessly connect cross-border logistics and effortlessly expand your global market!</div></div></div>", 1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { style: {"font-size":"30px","font-weight":"600","line-height":"38px","margin-bottom":"24px"} }, "Log In", -1)),
        _createVNode(_component_a_spin, { spinning: _ctx.loadingType }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form, {
              hideRequiredMark: true,
              model: _ctx.formState,
              layout: "vertical",
              name: "normal_login",
              class: "login-form",
              style: {"font-size":"16px"},
              onFinish: _ctx.onFinish,
              onFinishFailed: _ctx.onFinishFailed
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form_item, {
                  label: "Username",
                  name: "username",
                  rules: [{ required: true, message: 'Please input your username!', trigger: 'blur' }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      size: "large",
                      value: _ctx.formState.username,
                      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formState.username) = $event))
                    }, {
                      suffix: _withCtx(() => [
                        _createVNode(_component_UserOutlined, { class: "site-form-item-icon" })
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, {
                  label: "Password",
                  name: "password",
                  rules: [{ required: true, message: 'Please input your password!', trigger: 'blur' }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input_password, {
                      size: "large",
                      value: _ctx.formState.password,
                      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.password) = $event))
                    }, {
                      iconRender: _withCtx((v) => [
                        v
                          ? (_openBlock(), _createBlock(_component_UnlockOutlined, {
                              key: 0,
                              class: "site-form-item-icon",
                              style: {"color":"rgba(0,0,0,0.88)"}
                            }))
                          : (_openBlock(), _createBlock(_component_LockOutlined, {
                              key: 1,
                              class: "site-form-item-icon",
                              style: {"color":"rgba(0,0,0,0.88)"}
                            }))
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      size: "large",
                      type: "primary",
                      "html-type": "submit",
                      class: "login-form-button",
                      block: ""
                    }, {
                      default: _withCtx(() => _cache[2] || (_cache[2] = [
                        _createTextVNode("Login")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model", "onFinish", "onFinishFailed"])
          ]),
          _: 1
        }, 8, ["spinning"])
      ])
    ])
  ]))
}